import React from 'react';

const tooltipPosition = (posX, posY) => {
  let result = '';
  posY > 0.5
    ? result += 'c--bottom '
    : result += 'c--top ';
  posX > 0.5
    ? result += 'c--right'
    : result += 'c--left';
  return result;
}


const Tooltip = ({ body, posX, posY }) => (
  <div className={`a-tooltip ${tooltipPosition(posX, posY)}`}>
    <div className="a-body" style={body.length < 20 ? { textAlign: 'center' } : {}} >
      <span>{body}</span>
      <div className="a-caret">
        <div className="a-c1"></div>
        <div className="a-c2"></div>
      </div>
    </div>
  </div>
);

Tooltip.defaultProps = {
  posX: 0,
  posY: 0,
  body: 'EN Welcome from Tooltip'
};

export default Tooltip;